<template>
  <div>
    <Detail_employee/>
  </div>
</template>

<script>
import Detail_employee from "@/components/adminArin/admin_overall/Detail_employee";
export default {
  name: "DetailEmployee",
  components: {
    Detail_employee
  }
}
</script>

<style scoped>

</style>
